<template>
  <div class="share-social d-flex justify-end">
    <TooltipWidget
      v-for="({ link, icon, text }, i) in sharelinks"
      :key="i"
      bottom
      :tip="`Compartilhar no ${text}`"
    >
      <v-btn
        icon
        target="_blank"
        :href="link + currentUrl"
        :width="smAndDown ? `30px` : `38px`"
        :height="smAndDown ? `30px` : `38px`"
      >
        <v-icon :size="smAndDown ? `16` : `20`" color="primary">{{
          icon
        }}</v-icon>
      </v-btn>
    </TooltipWidget>
  </div>
</template>

<script>
import TooltipWidget from "./TooltipWidget.vue";
export default {
  data: () => ({
    sharelinks: [
      {
        link: `https://www.facebook.com/sharer/sharer.php?u=`,
        text: "Facebook",
        icon: "fab fa-facebook-f",
      },
      {
        link: "https://api.whatsapp.com/send/?text=",
        text: "WhatsApp",
        icon: "fab fa-whatsapp",
      },
      {
        link: "https://twitter.com/intent/tweet?url=",
        text: "Twitter",
        icon: "fab fa-twitter",
      },
    ],
  }),
  components: { TooltipWidget },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUrl() {
      return window.location.href;
    },
  },
};
</script>
